export default "__VITE_ASSET__D8C8EWpj__"